import { alpha } from '@mui/material/styles';

export default function Link(theme) {
  const isDark = theme.palette.mode === 'dark';
  const linkColor = theme.palette.brand.link;
  const hoverColor = theme.palette.brand.linkHover;

  return {
    MuiLink: {
      styleOverrides: {
        root: {
          color: linkColor,
          fontWeight: isDark ? 600 : 500,
          textDecoration: 'none',
          textUnderlineOffset: 4,
          transition: theme.transitions.create(['color', 'text-decoration'], {
            duration: theme.transitions.duration.shorter
          }),
          '&:hover': {
            color: hoverColor,
            textDecoration: 'underline',
            textDecorationThickness: '2px'
          },
          '&:focus-visible': {
            outlineOffset: 2,
            outline: `2px solid ${alpha(linkColor, 0.5)}`
          }
        }
      }
    }
  };
}
